const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/AppointmentPage.tsx';
import { RouteComponentProps } from 'react-router';
import { useIntl } from 'react-intl';
import * as React from 'react';
import { IconClass } from '@cistec/common_web/defs/icons';
import { Page } from '../Page';
import Grid from '@mui/material/Grid';
import { AppointmentTitleRow } from './components/AppointmentTitleRow';
import { AppointmentTimeRow } from './components/AppointmentTimeRow';
import { AppointmentDetailsRow } from './components/AppointmentDetailsRow';
import { AppointmentAddToCalendarRow } from './components/AppointmentAddToCalendarRow';
import { AppointmentLocationRow } from './components/AppointmentLocationRow';
import { AppoinmentButtonsRow } from './components/AppoinmentButtonsRow';
import textMap from 'App/pages/appointment/translations';
import { GoToAppointmentListButton } from './components/GoToAppointmentListButton';
import { GoToAppointmentBookingButton } from './components/GoToAppointmentBookingButton';
import { GoToAppointmentRescheduleButton } from './components/GoToAppointmentRescheduleButton';
import { AppointmentConfirmButton } from './components/AppointmentConfirmButton';
import { useStructuredAppointment } from 'App/store/appointment';

export interface IAppointmentBookingPageProps {}

interface IRouteParams {
    termnr: string;
}

export const AppointmentPage = (props: IAppointmentBookingPageProps & RouteComponentProps<IRouteParams>) => {
    const { formatMessage } = useIntl();

    const terminNr = props.match.params.termnr;
    const { data: appointment } = useStructuredAppointment(terminNr);

    if (!appointment) return null;

    return (
        <Page title={formatMessage(textMap.appointment)} iconClass={IconClass.Calendar}>
            <Grid container spacing={2}>
                <AppointmentTitleRow appointment={appointment} />
                <AppointmentTimeRow appointment={appointment} />
                <AppointmentDetailsRow appointment={appointment} />
                <AppointmentAddToCalendarRow appointment={appointment} />
                <AppointmentLocationRow appointment={appointment} />
                <AppoinmentButtonsRow>
                    <GoToAppointmentListButton />
                    <GoToAppointmentBookingButton />
                    <GoToAppointmentRescheduleButton appointment={appointment} />
                    <AppointmentConfirmButton appointment={appointment} />
                </AppoinmentButtonsRow>
            </Grid>
        </Page>
    );
};
